/**
 * Redux action creators for timer state management
 * Centralized to avoid repetition across the component
 */
import {
  setTimeData,
  setProjectData,
  setTaskData,
  setIsRunningData,
  setRunningTaskData,
  setTagData,
  setTagIdData,
  setProjectIdData,
  setSprintNameData,
  setSprintIdData,
  setClientData,
  setClientIdData,
  setIsbillableData,
} from "../../../../../features/timeTrackerData/timeTrackerLogSlice.js";

/**
 * Creates the Redux actions object for timer state management
 * @returns {Object} Object containing all Redux action creators
 */
export const createTimerReduxActions = () => ({
  setTimeData,
  setProjectData,
  setTaskData,
  setIsRunningData,
  setRunningTaskData,
  setTagData,
  setTagIdData,
  setProjectIdData,
  setSprintNameData,
  setSprintIdData,
  setClientData,
  setClientIdData,
  setIsbillableData,
});
